import { useAuthStore } from 'src/domain/stores/useAuthStore';

export const useActiveLanguage = () => useAuthStore((state) => state.language);
